
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/view/privacy_policy",
      function () {
        return require("private-next-pages/view/privacy_policy.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/view/privacy_policy"])
      });
    }
  